import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({

        progress: {
            margin: 2,
            color: theme.palette.primary.main
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        card: {
            minWidth: 275,
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
        fab: {
            iconDelete: {
                margin: 2,
                fontSize: 32
            },
        },
        iconRemove: {
            color: '#ff7676 !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        iconEdit: {
            color: '#6b61ff !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        inline: {            
            cursor: 'pointer',            
            "&:hover": {
                color: theme.palette.primary.main
            },
        },
        data: {                        
            color: '#989898',
            fontSize: '.9em',            
        },
        icons: {
            color: '#159B78 !important',
            width: '18px'
        },
        titleCartoes: {
        }
    }));
}